export default __webpack_public_path__ + "static/media/pdf.5542573f.svg";